import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeUrl',
})
@Injectable({ providedIn: 'root' })
export class SafeUrlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(url: string): SafeResourceUrl | null {
    // Permite blobs locales y URLs de dominio permitido
    if (!url) return null;

    if (url.startsWith('blob:')) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    try {
      const parsedUrl = new URL(url);
      const allowedDomains = ['preaplicaciones.aragon.es', 'aplicaciones.aragon.es'];
      if (allowedDomains.includes(parsedUrl.hostname)) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }
    } catch {
      console.error('[SafeUrlPipe] Error al analizar la URL:', url);
    }
    return null;
  }
}
